import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const STORAGE_KEY = 'wt_storage_notice_v1';

export default function StorageNotice() {
  const [show, setShow] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) {
      setShow(true);
    }
  }, []);

  if (!show) return null;

  const accept = () => {
    localStorage.setItem(STORAGE_KEY, '1');
    setShow(false);
  };

  return (
    <div style={{
      position: 'fixed', bottom: 0, left: 0, right: 0, zIndex: 9990,
      background: 'var(--surface)',
      borderTop: '1px solid var(--border)',
      padding: '14px 16px calc(14px + env(safe-area-inset-bottom, 0))',
      display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap',
      boxShadow: '0 -4px 24px rgba(0,0,0,0.4)',
    }}>
      <p style={{ flex: 1, fontSize: '0.73rem', color: 'var(--text2)', lineHeight: 1.6, margin: 0, minWidth: 200 }}>
        WishMeet stores your session token in browser storage to keep you logged in.
        We do not use tracking cookies. See our{' '}
        <button
          onClick={() => navigate('/privacy-policy')}
          style={{ background: 'none', border: 'none', color: 'var(--accent)', padding: 0, cursor: 'pointer', textDecoration: 'underline', fontSize: 'inherit', fontFamily: 'inherit' }}
        >
          Privacy Policy
        </button>.
      </p>
      <button
        onClick={accept}
        style={{
          background: 'linear-gradient(135deg,var(--accent),var(--accent2))',
          color: '#fff', border: 'none', borderRadius: 50,
          padding: '8px 20px', fontSize: '0.78rem', fontWeight: 700,
          cursor: 'pointer', fontFamily: 'var(--font-body)',
          whiteSpace: 'nowrap', flexShrink: 0,
        }}
      >
        Got it
      </button>
    </div>
  );
}
